import { Directive, Input, HostListener, ElementRef, HostBinding, OnDestroy } from '@angular/core';

import { PopoverRef } from './popover-ref';
import { PopoverService } from './popover.service';

// default state makes it easier to check. isShown
// property without first checking if reference is there
const DEFAULT_POPOVER_STATE: PopoverRef = {
  isShown: false,
  element: null,
  update: function() {},
  destroy: function() {}
};

/**
 * Popover Directive
 *
 * When applied to dom element that dom element
 * because a host element for a popover. String,
 * template or component can be passed to the
 * popover.
 */
@Directive({
  selector: '[cfPopover]',
  exportAs: 'cfPopover'
})
export class PopoverDirective implements OnDestroy {
  private popover = DEFAULT_POPOVER_STATE;

  @Input() cfPopover;

  @Input() placement: 'bottom' | 'top' = 'bottom';

  @Input() maxWidth = 300;

  @Input() modalPopover = false; // if popover is in modal

  @Input()
  get isShown(): boolean {
    return this.popover.isShown || false;
  }

  set isShown(value: boolean) {
    if (value) {
      this.show();
    } else if (
      !value &&
      this.popover.isShown // make sure we only hide if there is on existing
    ) {
      this.hide();
    }
  }

  @HostListener('click')
  onClick() {
    if (this.popover.isShown) {
      this.hide();
    } else {
      this.show();
    }
  }

  @HostListener('document:touchend', ['$event']) // for iOS devices
  onDocumentTouch(event) {
    this.handleDocumentClick(event);
  }

  @HostListener('document:click', ['$event'])
  onDocumentClick(event) {
    this.handleDocumentClick(event);
  }

  constructor(
    private element: ElementRef,
    private popoverService: PopoverService
  ) { }

  show() {
    this.popover = this.popoverService.showPopover(
      this.element.nativeElement,
      this.cfPopover,
      {
        placement: this.placement,
        maxWidth: this.maxWidth,
        modalPopover: this.modalPopover
      }
    );
  }

  hide() {
    this.popover.destroy();
    this.popover = DEFAULT_POPOVER_STATE;
  }

  /**
   * Update the popover position. Should be called if the content of
   * the popover changes and it is no longer positioned correctly.
   */
  update() {
    if (this.popover.isShown) {
      this.popover.update();
    } else {
      console.error('Attempted to update a hidden popover. Ensure the popover is shown before calling popover.update();');
    }
  }

  ngOnDestroy() {
    this.popover.destroy();
  }

  private handleDocumentClick(event) {
    if (this.popover.isShown) {
      if (!(
        // user didn't click popover
        event.target.contains(this.popover.element) ||
        // user didn't click child of popover
        this.popover.element.contains(event.target) ||
        // user didn't click the trigger element
        event.target === this.element.nativeElement ||
        // if user clicks child element of element
        this.element.nativeElement.contains(event.target)
      )) {
        // close the popover
        this.hide();
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/datepicker/popover/popover.directive.ts